import { TPartnersRow, TReferralsPartnersRow } from 'redux/reducers/referrals/types';
import { TUser } from 'redux/reducers/user/types';
import { DATES_ID, DATES } from 'services/constants/dates-constants';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<keyof TPartnersRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Partner Name',
		selector: 'partnerName',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Registration Address',
		selector: 'registrationAddress',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.MULTILINE_TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Bank Account Details',
		selector: 'bankAccountDetails',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Partners Fee',
		selector: 'partnersFee',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: (item) => '%',
	},
	{
		name: 'Actions',
		selector: 'id',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{ name: 'Edit', icon: EIconButtons.EDIT },
			{ name: 'Reports', label: 'Fees reports', icon: EIconButtons.SUMMARIZE },
		],
	},
];

const historyOfChanges = [
	{
		name: 'created',
		createdBy: {
			id: '74ce3b5e-a492-49ae-8d8a-8609b275805d',
			email: 'andrii@easproject.com',
			fullName: 'Andrii',
		},
		date: '2025-06-10T13:21:35.780131Z',
	},
	{
		name: 'updated',
		createdBy: {
			id: '74ce3b5e-a492-49ae-8d8a-8609b275805d',
			email: 'andrii@easproject.com',
			fullName: 'Andrii',
		},
		date: '2025-06-10T13:21:35.780131Z',
	},
	{
		name: 'deleted',
		createdBy: {
			id: '74ce3b5e-a492-49ae-8d8a-8609b275805d',
			email: 'andrii@easproject.com',
			fullName: 'Andrii',
		},
		date: '2025-06-10T13:21:35.780131Z',
	},
];
